module.exports = __webpack_public_path__ + "static/media/Vaibhav.eeeb415a.jpeg";